import { Fragment, type FC } from "react";
import { useTranslation } from "react-i18next";
import { FormControl, FormField, FormItem, FormMessage } from "@ui/Form";
import NumberInput from "@ui/NumberInput";
import { TABLE_HOURS_COUNT } from "@/constants/validation";
import { useMultiStepForm } from "@/hooks";

export const TableSubForm: FC = () => {
  const { t } = useTranslation();
  const { form } = useMultiStepForm();

  return (
    <div className="space-y-6">
      <h2 className="leading-[140%] font-semibold">{t("step1.table_subform.q1")}</h2>

      <div className="grid grid-cols-[auto_1fr] gap-x-6 gap-y-3 px-2 md:px-4">
        <p>{t("step1.table_subform.hour")}</p>
        <p>{t("step1.table_subform.consumption")}</p>

        {Array.from({ length: TABLE_HOURS_COUNT }, (_, i) => i + 1).map(hour => {
          const hourIndex = hour - 1;
          const fieldError = form.formState.errors.step1?.tableData?.[hourIndex];

          return (
            <Fragment key={hour}>
              <div className="ml-auto flex size-10 items-center justify-center text-center font-normal">
                {hour}
              </div>

              <FormField
                control={form.control}
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                name={`step1.tableData.${hourIndex}`}
                render={({ field }) => (
                  <FormItem className="gap-1">
                    <FormControl>
                      <NumberInput
                        className="h-10 w-[172px]"
                        {...field}
                        value={field.value ?? ""}
                        isError={Boolean(fieldError)}
                        unit={t("MW")}
                      />
                    </FormControl>
                    {fieldError && (
                      <FormMessage data-test="table-data-error">{fieldError.message}</FormMessage>
                    )}
                  </FormItem>
                )}
              />
            </Fragment>
          );
        })}
      </div>
    </div>
  );
};
